import { IExplorer } from '@/types/explorer';
import { getDefaultByWeekData, getProgressData } from '@/utils/explorer';
import { apiCall } from '@/utils/api';

export const getMainExplorerData = async () => {
  const EXPLORER_ROUTE = '/explorer';

  try {
    const data: IExplorer = await apiCall(
      `${process.env.NEXT_PUBLIC_API}${EXPLORER_ROUTE}`,
      { method: 'GET' },
    );

    // Region data transformation
    if (data?.regions) {
      data.regions = data.regions.map(region => {
        const {
          coverageProgressByWeek = getDefaultByWeekData(0),
          activityProgressByWeek = getDefaultByWeekData(0),
          mapProgressByWeek = getDefaultByWeekData(0),
          resilienceProgressByWeek = getDefaultByWeekData({
            progress: 0,
            hist: null,
          }),
        } = region;

        const coverageProgress = getProgressData(coverageProgressByWeek) || 0;
        const activityProgress = getProgressData(activityProgressByWeek) || 0;
        const overallProgress = getProgressData(mapProgressByWeek) || 0;
        const resilienceProgress =
          getProgressData(resilienceProgressByWeek) || 0;

        const mostRecentDay = data?.stats?.mostRecentDay || '';
        // this is the same as overallProgress but with a different name
        // for sorting purposes on regions table
        const multiplierFactor = overallProgress;

        return {
          ...region,
          coverageProgressByWeek,
          activityProgressByWeek,
          mapProgressByWeek,
          resilienceProgressByWeek,
          coverageProgress,
          activityProgress,
          overallProgress,
          resilienceProgress,
          multiplierFactor,
          mostRecentDay,
        };
      });
    }
    return data;
  } catch (error) {
    console.log(error);
  }
};
